/**
 * 根据新电话号输入规则，电话号码只有10位
 * input example (223) 8888-8888
 * output 22388888888
 * @param {*} phone string
 */
type useProps = {
  phone: string;
};
export const formatAmericaPhoneToNumber = (phone): useProps => {
  const result = (phone || '').replace(/[\s|(|)|*|A-Za-z|-]/g, '');
  return result.slice(0, 10);
};

/**
 * 关于首位是国际代码的手机格式化（根据新电话号码输入规则可以废弃，稍后再删除）
 * @param phone
 * @returns
 */
export const formatePhoneWithCountry = phone => {
  if (!phone) return '';
  const hasCountry = phone?.length >= 10 && +phone.substr(0, 1) === 1;
  const res = formateAmericaPhone(hasCountry ? phone.substr(1) : phone);
  return hasCountry ? `1${res}` : res;
};

/**
 * (415) 886-5523 格式化为美国手机号
 * 兼容旧数据，超过10位的手机号
 * @param phone
 */
export const formateAmericaPhone = phone => {
  let x;
  let phoneNum = (phone || '').replace(/[^\d|\*]/g, '');
  if (phoneNum?.length >= 11) {
    x = phoneNum.match(/(\d{0,3})([\d|\*]{8,})/);
  } else {
    x = phoneNum.match(/(\d{0,3})([\d|\*]{0,3})(\d{0,4})/);
  }
  const result = !x[1] ? '' : !x[2] ? '(' + x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
  return result;
};

/**
 * 检查手机号是否脱敏
 * @param phone
 * @returns
 */
export const isPhoneDesensitize = phone => {
  if (!!phone && phone.includes('*')) return true;
  return false;
};
